import { Box, BoxProps, Button, Flex, Heading } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocationsQuery } from 'generated/graphql';
import { Link } from 'react-router-dom';
import LocationListItem from './LocationListItem';

function LocationList(props: BoxProps) {
  const { data, loading } = useLocationsQuery();

  if (loading) return null;

  return (
    <Box {...props} borderRight="1px" borderColor="gray.200" pr={3}>
      <Flex justify="space-between" align="center">
        <Heading as="h3">Locations</Heading>
        <Button as={Link} to="new" variant="ghost">
          <FontAwesomeIcon icon={['fal', 'location-plus']} size="lg" />
        </Button>
      </Flex>
      <Box mt={4}>
        {data?.locations?.edges?.map(location => (
          <LocationListItem key={location?.node?.id} {...location?.node} />
        ))}
      </Box>
    </Box>
  );
}

export default LocationList;
